<template>
  <div class="cs-incompleteWorkflowList">
    <pagination
      v-loading="loading"
      :data="listData"
      :option="paginationOption"
      @search="search"
      @loadData="onLoadList"
      @pageSizeChange="pageSizeChange"
      @currentPageChange="currentPageChange"
      @edit="onEdit"
      @delete="onDelete"
    ></pagination>
  </div>
</template>

<style lang="scss" scoped>
  .cs-incompleteWorkflowList{
    padding: 0 30px 10px 30px; 
  }
</style>

<script>
import pagination from "../common/pagination";
import { getIncompleteWorkflowList,removeWorkflow } from "../../service/enrollmentFee.service";
export default {
  props:{
    username:String
  },
  data() {
    return {
      loading: false,
      listData: [],
      paginationOption: {},
      pageSize: 20,
      searchPhone: ""
    };
  },
  components: {
    pagination
  },
  created() {
    this.paginationOption = {
      displayPagination: true,
      hasEditButton: true,
      editButtonText: "查看",
      hasAddButton: false,
      hasSearch: false,
      hasDeleteButton:true,
      deleteButtonText:"撤销"
    };
    this.search();
  },
  methods: {
    onDelete(index, row){
      this.$confirm("是否撤销该流程?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
        }).then(() => {
          this.removeWorkFlow(row.Id);
        }).catch(() => {
          
        });
    },
    removeWorkFlow(id){
      if (!!id){
        this.loading = true;
        removeWorkflow(id).then(result=>{
          if (!!result && result.success){
            this.$message({
              message: "撤销流程成功",
              type: "success"
            });
            this.$emit("reloadCount");
            this.search();
          }else{
           this.$message({
              message: result.message,
              type: "error"
            });
          }
        });
      }
    },
    onEdit(index, row){
      this.$emit("view", row);
    },
    search(pageNumber) {
      let pageData = this.getSearchPageData(pageNumber);
      this.loadListData(pageData);
    },
    onLoadList(pageData) {
      this.search(pageData.pageNumber);
    },
    loadListData(pageData) {
      this.loading = true;
      getIncompleteWorkflowList(pageData)
        .then(result => {
          if (!!result && result.success) {
            this.listData = result.data;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    pageSizeChange(value) {
      // if (this.isDataChange()){
      //   return;
      // }
      this.pageSize = value;
    },
    currentPageChange(value) {
      this.listData.CurrentPage = value;
    },
    getSearchPageData(pageNumber) {
      if (typeof pageNumber == "undefined") {
        pageNumber = 1;
      }

      let pageData = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        keyWord: this.searchPhone,
      };
      return pageData;
    }
  },
  watch:{
    username:function(){
      this.search();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/addCollectFees/incompleteWorkflowList.vue